import { PageSection, Partnership, Table, TableColumnHeader, TableRow } from '@/common'
import MissingResourcesAlert from '@/components/MissingResourcesAlert'
import { LoadingScreen } from '@/shared/components'
import useDialog from '@/common/hooks/useDialog'
import { useState } from 'react'
import useI18n from '@/shared/hooks/useI18n'
import IncomingImporterRow from './components/IncomingImporterRow'
import RejectImporterDialog from './dialogs/RejectImporterDialog'

export default function ImportersIncomingInvitations({
  pendingPartnerships,
  isLoading
}: {
  pendingPartnerships: Partnership[]
  isLoading: boolean
}) {
  const { t } = useI18n()
  const {
    open: isRejectDialogOpen,
    openDialog: openRejectDialog,
    closeDialog: closeRejectDialog
  } = useDialog()
  const [selectedPartnership, setSelectedPartnership] = useState<Partnership>()
  const hasPendingPartnerships = pendingPartnerships.length > 0

  return (
    <PageSection title={t('importers:importerIncomingList.title')}>
      {isLoading && <LoadingScreen />}
      {!isLoading && !hasPendingPartnerships && (
        <MissingResourcesAlert
          title={t('importers:importerIncomingList.noIncomingInvitations.title')}
          description={t('importers:importerIncomingList.noIncomingInvitations.description')}
        />
      )}
      {hasPendingPartnerships && (
        <Table className="table-fixed">
          <thead>
            <TableRow>
              <TableColumnHeader className="w-72">
                {t('importers:importerIncomingList.table.importerName')}
              </TableColumnHeader>
              <TableColumnHeader className="w-48">
                {t('importers:importerIncomingList.table.dateOfInvitation')}
              </TableColumnHeader>
              <TableColumnHeader className="w-48">
                {t('importers:importerIncomingList.table.actions')}
              </TableColumnHeader>
            </TableRow>
          </thead>
          <tbody>
            {pendingPartnerships.map(partnership => {
              return (
                <IncomingImporterRow
                  key={partnership.id}
                  partnership={partnership}
                  onReject={() => {
                    setSelectedPartnership(partnership)
                    openRejectDialog()
                  }}
                />
              )
            })}
          </tbody>
        </Table>
      )}
      <RejectImporterDialog
        isOpen={isRejectDialogOpen}
        onClose={closeRejectDialog}
        partnership={selectedPartnership}
      />
    </PageSection>
  )
}
